import React, { createContext, useContext, useState, useCallback } from "react";
import PropTypes from "prop-types";

const AppContext = createContext({
  showAppSpinner: () => {},
  hideAppSpinner: () => {},
  showAppSpinnerState: false
});

export const AppProvider = ({ children }) => {
  const [showAppSpinnerState, setShowAppSpinnerState] = useState(false);

  const showAppSpinner = useCallback(() => setShowAppSpinnerState(true), []);
  const hideAppSpinner = useCallback(() => setShowAppSpinnerState(false), []);

  return (
    <AppContext.Provider value={{ showAppSpinner, hideAppSpinner, showAppSpinnerState }}>
      {children}
    </AppContext.Provider>
  );
};

AppProvider.propTypes = {
  children: PropTypes.node.isRequired
};

export const useAppContext = () => useContext(AppContext);
